'use strict';

var SystemStatusReoptimizationDirective = function SystemStatusReoptimizationDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-reoptimization.html'),
    controller: 'SystemStatusReoptimizationController',
    link: function link(scope) {
      scope.$on('system-reoptimization-status:reoptimize', scope.reoptimize);
      scope.$on('system-reoptimization-status:cancel', scope.cancelOptimization);
    }
  };
};
SystemStatusReoptimizationDirective.$inject = [];
module.exports = SystemStatusReoptimizationDirective;